import { RouteConfig } from 'vue-router'

const Index = () => import('./new-semester/index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/new-semester-2025',
  name: 'activity_new_semester_2025',
  meta: {
    title: '2025新学期',
    ignoreLogin: true,
  },
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [indexRoute]
